import { gql } from "@apollo/client"

export const SAVE_FEEDBACK_RESPONSE = gql`
  mutation saveFeedbackResponse($data: SaveFeedbackPrompt!) {
    feedback {
      saveFeedbackResponse(data: $data)
    }
  }
`
